import {Auditoria} from "../../bibliotecaPjus/models/comum.models";
import {IFormulario, IModel} from "../../bibliotecaPjus/models/contrato.models";
import {FormControl, FormGroup, Validators} from "@angular/forms";

export class Negociacao extends Auditoria implements IModel, IFormulario {

  valorOfertaAnterior: number;
  valorOferta: number;
  valorContraProposta: number;
  observacaoParceiro: string;
  dataPropostaPjus: string;
  dataContraProposta: string;
  observacaoPjus: string;
  statusNegociacao: string;

  form: FormGroup;

  constructor(other?: any) {
    super(other);
    if (other) {
      this.valorOfertaAnterior = other.valorOfertaAnterior;
      this.valorOferta = other.valorOferta;
      this.valorContraProposta = other.valorContraProposta;
      this.observacaoParceiro = other.observacaoParceiro;
      this.dataPropostaPjus = other.dataPropostaPjus;
      this.dataContraProposta = other.dataContraProposta;
      this.observacaoPjus = other.observacaoPjus;
      this.statusNegociacao = other.statusNegociacao;
    }
  }

  get asForm(): FormGroup {
    if (this.form == null) {
      this.form = new FormGroup({ });
    }
    return this.form;
  }

  updateForm(other): void {
    this.form.patchValue(other);
  }
}

